import styled from "styled-components";

export const SearchWrapper = styled.div`
  display: flex;
  flex: 1;
  gap: 4rem;
  width: 100%;
`;
